import BaseViewerController from "./base_viewer_controller"
import Viewer from 'viewerjs'

const ROTATE_COUNTER_CLOCKWISE = true

export default class extends BaseViewerController {
  static targets = ["container", "zoomDisplay"]

  connect() {
    super.connect()
    this.initializeViewer()
  }

  initializeViewer() {
    if (!this.hasContainerTarget) {
      console.error('Container target not found')
      return
    }

    try {
      const img = this.element.querySelector('img')
      if (!img) {
        console.error('No image found in element')
        return
      }

      this.imgElement = img

      const initViewer = () => {
        this.viewer = new Viewer(this.imgElement, {
          inline: true,
          container: this.containerTarget,
          navbar: false,
          title: false,
          toolbar: false,
          button: false,
          zoomRatio: this.zoomStepValue,
          minZoomRatio: this.minZoomValue,
          maxZoomRatio: this.maxZoomValue,
          viewed: () => {
            this.imgElement.style.visibility = 'hidden'
            this.updateZoomDisplay()
          },
          zoomed: () => {
            this.updateZoomDisplay()
          }
        })
      }
      this.rotationDelta = ROTATE_COUNTER_CLOCKWISE ? -90 : 90

      if (this.imgElement.complete) {
        initViewer()
      } else {
        this.imgElement.addEventListener('load', initViewer)
        this.imgElement.addEventListener('error', (e) => {
          console.error('Image failed to load:', e)
          this.handleError('Failed to load image')
        })
      }
    } catch (error) {
      console.error('Error initializing image viewer:', error)
      this.handleError('Failed to initialize image viewer')
    }
  }

  zoomIn() {
    this.viewer?.zoom(this.zoomStepValue)
  }

  zoomOut() {
    this.viewer?.zoom(-1 * this.zoomStepValue)
  }

  rotate() {
    this.viewer?.rotate(this.rotationDelta)
  }

  updateZoomDisplay() {
    if (!this.hasZoomDisplayTarget || !this.viewer) return

    const ratio = this.viewer.imageData?.ratio
    if (ratio) {
      const zoomPercent = Math.round(ratio * 100)
      this.zoomDisplayTarget.textContent = `${zoomPercent}%`
    }
  }

  cleanup() {
    super.cleanup()
    try {
      this.viewer?.destroy()
      this.viewer = null
    } catch (error) {
      console.error('Error during cleanup:', error)
    }
    if (this.imgElement) {
      this.imgElement.style.visibility = 'visible'
    }
  }
}
